// @ngInject
function TranslateHelper($translate, $q, $timeout) {
    // Helper service for checking if translations has been loaded or not.
    return {
        isReady: isReady
    };

    function isReady(interval = 50, maxRetries = 100){
        var guaranteedKey = 'main.title';
        var attempts = 0;

        var deferred = $q.defer();

        const check = function() {
            const value = $translate.instant(guaranteedKey);
            attempts++;

            // Value has been translated successfully - which means that translations are ready.
            if (value !== guaranteedKey){
                deferred.resolve();
            }
            // Keep trying
            else{
                if(attempts >= maxRetries){
                    console.warn(`translateHelper.isReady: "${guaranteedKey}" not loaded after ${attempts} attempts`);
                    deferred.resolve();
                }
                else
                    $timeout(check, interval);
            }
        };

        check();
        return deferred.promise;
    }
}

angular
    .module('services.translateHelper', [])
    .factory('TranslateHelper', TranslateHelper);